<template>
	<div>
		<Header @getHeaderHeight="getHeaderHeight"></Header>
		<div class="page" :style="{ 'padding-top': headerHeight - 1 + 'px' }">
			<div class="page-header">
				<div class="page-header-container">
					<div class="page-header-inner">
						<div class="fx">
							<div class="page-header-left">
								<div class="page-header-title">
									<h1>Aurora W2</h1>
								</div>
								<div class="content custom">
									<div class="check-item">
										<div class="img-wrap">
											<img src="../../static/img/check.png" alt="">
										</div>
										<div class="text">{{ $t('feature.aurora.f')}}</div>
									</div>
									<div class="check-item">
										<div class="img-wrap">
											<img src="../../static/img/check.png" alt="">
										</div>
										<div class="text">{{ $t('feature.aurora.s')}}</div>
									</div>
								</div>
								<div class="nav-link">
									<div class="buy-wrap bg-0c" @click="onBuy">
										{{ $t('available')}}
									</div>
									<div class="nav-conn">
										<a href="javascript: void (0)" class="link" @click="onTele">
											<span class="iconfont icon-a-telegram"></span>
										</a>
										<a href="javascript: void (0)" class="link pl8" @click="onWhatapp">
											<span class="iconfont icon-whatsapp"></span>
										</a>
									</div>
								</div>
							</div>
							<div class="page-header-right">
								<LazyImage className="viewport" imagePath="/res/img/swiper_3.png"></LazyImage>
							</div>
						</div>
					</div>
				</div>
				<div class="preview-wrap">
					<div class="preview-inner">
						<div class="fx">
							<div class="product-list-wrap">
								<div class="product-item" v-for="(img, index) in imgList" :key="index"
									@click="showPicture(img)">
									<img :src="`/res/img/${img.path}`" alt="" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="equipment-parameters" id="equipment-parameters">
			<div class="equipment-parameters-wrap">
				<div class="equipment-parameters-inner">
					<h2>{{ $t('feature.specification') }} </h2>
					<h4>{{ $t('feature.product') }} </h4>
					<div class="equipment-content-main">
						<div class="min-equipment">
							<ul class="equipment-ul-list">
								<li v-for="(title, i) in list" :key="i" :class="curIndex == i ? 'active' : ''">
									<a href="javascript: void (0)" @click="checkData(i)">{{ title.category }}</a>
								</li>
							</ul>
							<div class="equipment-table-wrap">
								<table>
									<tbody v-for="(data, idx) in midData" :key="idx">
										<tr class="key">
											<div>{{ data.name }}</div>
										</tr>
										<tr class="val">
											<div>{{ data.value }}</div>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
						<p class="equipment-content" v-for="(product, index) in list" :key="index">
						<table>
							<thead>
								<tr>
									<th>{{ product.category }}</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(s, idx) in product.specs" :key="idx">
									<td class="parameters-name">{{ s.name }}</td>
									<td class="parameters-detail">{{ s.value }}</td>
								</tr>
							</tbody>
						</table>
						</p>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
		<div class="dialog" v-show="isShow">
			<div class="mask"></div>
			<div class="dialog-content">
				<div class="dialog-inner" ref="inner" :class="isShow ? 'scale-in-center' : 'scale-out-center'">
					<img :src="`/res/img/${path}`" alt="">
				</div>
				<div class="close" @click="closePicture" :class="isShow ? 'scale-in-center' : 'scale-out-center'">
					<span class="iconfont icon-guanbi"></span>
				</div>
				<div class="banner-swiper">
					<div class="prev" @click="onPrev">
						<span class="iconfont icon-zuojiantou"></span>
					</div>
					<div class="next" @click="onNext">
						<span class="iconfont icon-youjiantou"></span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Header from '../header/index.vue'
	import Footer from '../footer/index.vue'
	export default {
		name: 'AuroraW2',
		components: {
			Header,
			Footer
		},
		data() {
			return {
				headerHeight: '',
				isShow: false,
				path: 'aurora/aurora1_2.png', // 使用v-show 需指定默认值
				imgList: [{
						path: 'aurora/aurora1.png',
						dPath: 'aurora/aurora1_2.png'
					},
					{
						path: 'aurora/aurora2.png',
						dPath: 'aurora/aurora2_2.png'
					},
					{
						
						path: 'aurora/aurora3.png',
						dPath: 'aurora/aurora3_2.png'
					},
					{
						path: 'aurora/aurora4.png',
						dPath: 'aurora/aurora4_2.png'
					},
					{
						path: 'aurora/aurora5.png',
						dPath: 'aurora/aurora5_2.png'
					}
				],
				list: [{
						category: "Packing",
						specs: [{
								name: "Product Dimension",
								value: "105*105*15mm"
							},
							{
								name: "Packaged Size",
								value: "195*115*65cm"
							},
							{
								name: "Packaged Weight",
								value: "0.4KG"
							}
						]
					},
					{
						category: "Hardware",
						specs: [{
								name: "CPU",
								value: "Amlogic S905W2 Quad Core, ARM® Cortex™-A35"
							},
							{
								name: "GPU",
								value: "ARM Mali-G31 MP2"
							},
							{
								name: "RAM",
								value: "4Gb"
							},
							{
								name: "ROM",
								value: "32Gb"
							},
							{
								name: "DC In",
								value: "DC 5V/2A"
							},
							{
								name: "USB Host",
								value: "2 High speed USB 2.0"
							},
							{
								name: "Card Reader",
								value: "TF Card reader"
							},
							{
								name: "Lan",
								value: "RJ45 Ethernet port"
							},
							{
								name: "Wifi",
								value: "Built-in Wifi, 802.1.1b/g/n"
							},
							{
								name: "AV In",
								value: "AV(3 in 1) port"
							},
							{
								name: "SPDIF",
								value: "Coaxial(Optical)"
							},
							{
								name: "Power Indicator",
								value: "Power On：Blue"
							}
						]
					},
					{
						category: "Software",
						specs: [{
								name: "O.S.",
								value: "Android 11"
							},
							{
								name: "KODI",
								value: "17.6"
							},
							{
								name: "Decoder Formats",
								value: ""
							},
							{
								name: "Video Formats",
								value: "4K,H.265,MPEG1/2/4,H.264,HD AVC/VC-1,RM/RMVB,Xvid/DivX3/4/5/6,RealVideo8/9/10"
							},
							{
								name: "Music format",
								value: "MP1, MP2, MP3, WMA, OGG, AAC, M4A, FLAC, APE, AMR, RA, WAV"
							},
							{
								name: "Photo format",
								value: "JPEG/BMP/GIF/PNG/TIFF"
							},
							{
								name: "DLNA",
								value: "DLNA files sharing"
							},
							{
								name: "Languages",
								value: "English/French/German/Spanish/Italian etc. 24 languages"
							},
							{
								name: "Network Functions",
								value: "Skype chatting,Picasa,Youtube,Flicker,Facebook,Online movies,etc."
							}
						]
					}
				],
				curIndex: 0
			};
		},
		computed: {
			midData() {
				return this.list[this.curIndex].specs || []
			}
		},
		methods: {
			getHeaderHeight(val) {
				this.headerHeight = val
			},
			showPicture(img) {
				this.path = img.dPath
				this.isShow = true
				this.$refs.inner.classList.remove('scale-out-center')
			},
			closePicture() {
				this.$refs.inner.classList.add('scale-out-center')
				this.isShow = false
			},
			checkData(idx) {
				this.curIndex = idx
			},
			onBuy() {
				return
			},
			onPrev() {
				let index = this.imgList.findIndex(item => item.dPath === this.path)
				if (index > 0) {
					this.path = this.imgList[--index].dPath
				}
			},
			onNext() {
				let index = this.imgList.findIndex(item => item.dPath === this.path)
				if (index < this.imgList.length - 1) {
					this.path = this.imgList[++index].dPath
				}
			},
			onTele() {
				window.open('https://t.me/AuroraMCPlayer')
			},
			onWhatapp() {
				window.open('https://wa.me/79315988108')
			}
		},
		created() {

		},
		mounted() {

		},
		updated() {},
	}
</script>
<style lang='less'>
	.banner-swiper {
		margin-top: 20px;
		display: flex;
		justify-content: center;
		gap: 20px;

		.prev,
		.next {
			width: 48px;
			height: 48px;
			line-height: 48px;
			color: #fff;
			text-align: center;
			background: #474a58;
			border-radius: 12px 12px 12px 12px;
			cursor: pointer;

			.iconfont {
				font-size: 20px;
			}
		}
	}

	.equipment-content-main {
		padding-bottom: 80px;
	}

	.header-wrapper {
		background-color: #051412;
	}

	.viewport {
		min-height: 405px;
	}

	.dialog {
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		z-index: 1025;

		.mask {
			position: absolute;
			left: 0;
			right: 0;
			bottom: 0;
			top: 0;
			background: rgba(0, 0, 0, 0.6);
		}

		.dialog-content {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			z-index: 102;

			.dialog-inner {
				min-width: 300px;
				min-height: 300px;

				img {
					width: 100%;
					height: 100%;
					border-radius: 30px;
				}
			}
		}

		.close {
			position: absolute;
			top: 20px;
			right: 20px;
			width: 48px;
			height: 48px;
			line-height: 48px;
			text-align: center;
			background: rgba(40, 47, 74, 0.5);
			cursor: pointer;
			border-radius: 12px;

			.iconfont {
				color: #fff;
				font-size: 25px;
			}
		}
	}

	.page {
		.page-header {
			.page-header-container {
				border-radius: 0 0 80px 0;
				min-height: 390px;
				display: flex;
				background: #051412;

				.page-header-inner {
					position: relative;
					max-width: 1280px;
					padding: 0 24px;
					margin: 0 auto;
					color: #fff;
					display: flex;
					flex-grow: 1;

					.fx {
						flex-grow: 1;
						display: flex;
						align-items: center;
						justify-content: space-between;

						.page-header-left {
							.page-header-title {
								padding-top: 8px;

								h1 {
									font-family: 'Alibaba PuHuiTi M';
									font-weight: bold;
									font-size: 40px;
									color: #FFFFFF;
									line-height: 40px;
								}
							}

							.content {
								padding-top: 16px;

								.check-item {
									display: flex;
									align-items: center;

									.img-wrap {
										width: 24px;
										height: 24px;

										img {
											width: 100%;
											height: 100%;
										}
									}

									.text {
										font-size: 20px;
										padding-left: 8px;
									}
								}
							}

							.nav-link {
								display: flex;
								align-items: center;
								padding-top: 16px;

								.buy-wrap {
									cursor: pointer;
									height: 40px;
									text-align: center;
									line-height: 16px;
									padding: 12px 20px;
									box-sizing: border-box;
									border-radius: 32px;
									background: #1ff8a1;
									color: #151515;
								}

								.nav-conn {
									display: flex;
									padding-left: 16px;

									.link {
										width: 40px;
										height: 40px;
										line-height: 28px;
										text-align: center;
										padding: 6px;
										border-radius: 8px;
										background: rgba(255, 255, 255, 0.1);

										.iconfont {
											font-size: 28px;
										}
									}

									.pl8 {
										margin-left: 8px;
									}
								}
							}
						}

						.page-header-right {

							img {
								display: block;
								width: 100%;
								height: 100%;
							}
						}
					}
				}
			}

			.preview-wrap {
				position: relative;
				top: 48px;
				z-index: 100;

				.preview-inner {
					max-width: 1280px;
					margin: 0 auto;
					padding: 0 24px;
					color: #49505E;
					box-sizing: border-box;

					.fx {
						display: flex;
						align-items: center;
						justify-content: space-between;
						height: 100%;

						.product-list-wrap {
							display: flex;

							.product-item {
								cursor: pointer;
								width: 80px;
								height: 100%;
								padding-right: 20px;
								box-sizing: content-box;

								img {
									width: 100%;
									height: 100%;
								}
							}
						}

						.preview-btn {
							display: flex;

							.link {
								width: 48px;
								height: 48px;
								text-align: center;
								line-height: 48px;
								margin-left: 20px;
								background: rgba(40, 47, 74, 0.1);
								border-radius: 32px 32px 32px 32px;
								border: 1px solid rgba(40, 47, 74, 0.1);

								.iconfont {
									font-size: 32px;
								}
							}

							.link:hover {
								background: #1ef8a0;
								color: #111836;
							}
						}
					}
				}

			}
		}
	}

	.equipment-parameters {
		padding-top: 60px;

		.equipment-parameters-wrap {
			.equipment-parameters-inner {
				max-width: 1280px;
				padding: 0 24px;
				margin: 0 auto;

				h2 {
					font-family: 'Alibaba PuHuiTi B';
					font-weight: bold;
					font-size: 32px;
					color: #151515;
					line-height: 38px;
				}

				h4 {
					font-family: 'Alibaba PuHuiTi B';
					font-size: 30px;
					font-weight: bold;
					color: #24DF94;
					line-height: 38px;
				}

				.min-equipment {
					display: none;
				}

				.equipment-table-wrap {
					display: none;
				}

				.equipment-table-wrap {
					padding: 24px 0 40px;

					table {
						width: 100%;
					}

					.key {
						color: #7C7C7C;
					}

					.val {
						color: #151515;
						box-sizing: border-box;

						div {
							margin: 12px 0 16px;
						}
					}
				}

				.equipment-content {
					padding-top: 40px;

					table {
						width: 100%;

						thead {
							tr {
								th {
									text-align: left;
								}
							}
						}

						tbody {
							tr {
								border-bottom: 1px solid #E8E8E8;

								td {
									padding: 16px 0;
								}

								.parameters-name {
									color: #7C7C7C;
								}

								.parameters-detail {
									text-align: right;
									color: #151515;
								}
							}
						}
					}
				}

			}
		}
	}

	@media (max-width: 1200px) {}

	@media (max-width: 768px) {
		.viewport {
			min-height: 215px !important;
		}

		.page-header-right {
			img {
				object-fit: contain;
			}
		}

		.equipment-ul-list {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding-top: 32px;
			padding-bottom: 12px;

			li {
				position: relative;

				a {
					color: #000000;
				}
			}

			.active::after {
				content: '';
				display: block;
				position: absolute;
				bottom: -12px;
				width: 100%;
				border: 2px solid #1EF8A0;
			}
		}

		.preview-wrap {
			overflow: hidden;

			.preview-inner {
				overflow-x: scroll;
			}
		}

		.equipment-content-main {
			.equipment-content {
				display: none;
			}

			.min-equipment {
				display: block !important;
			}

			.equipment-table-wrap {
				display: block !important;

				tbody {
					border-bottom: 1px solid #E8E8E8;

					.key {
						div {
							margin-top: 16px;
						}
					}
				}
			}
		}

		.page-header-inner {
			.fx {
				flex-direction: column;

				.page-header-left {
					width: 100%;
					text-align: center;
					position: relative;
					z-index: 101;

					.custom {
						.check-item {
							justify-content: center;
						}
					}

					.nav-link {
						justify-content: center;
					}
				}
			}
		}

		.page-header-right {
			top: auto !important;
			right: auto !important;
			bottom: -120px;
		}

	}
</style>